import { useTheme } from '@mui/material'
import clsx from 'clsx'
import { NOME_SELO, NOME_PREFIXO, NOME_SUFIXO, ASSINATURA, NOME_PRODUTO } from '../../libs/marca'

// A marca deixou de ser imagem. Antes eram três SVGs exportados à mão
// (logo-primary, logo-white, logo-primary-text-white) e a escolha do arquivo
// dependia do tema; agora é selo + texto, então acompanha o tema sozinha,
// escala em qualquer tamanho e não precisa de arquivo nenhum.

// Cada tamanho define o corpo do nome; o resto do lockup é proporcional a ele.
const TAMANHOS = {
  pequeno: 15,
  topo: 19,
  grande: 26
}

export default function Logo({
  tamanho = 'topo',
  white = false,
  assinatura = false,
  className = ''
}) {
  const theme = useTheme()
  const corpo = TAMANHOS[tamanho] || TAMANHOS.topo

  // Sobre fundo escuro fixo (a tela de login), o texto é sempre branco.
  const corDoNome = white ? '#ffffff' : theme.palette.text.primary
  const corDaAssinatura = white ? 'rgba(255,255,255,0.7)' : theme.palette.text.secondary

  return (
    <div
      className={clsx('flex items-center', className)}
      style={{ gap: corpo * 0.5 }}
      aria-label={NOME_PRODUTO}
    >
      <span
        aria-hidden="true"
        className="font-black leading-none flex-none"
        style={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.getContrastText(theme.palette.primary.main),
          fontSize: corpo * 0.68,
          letterSpacing: '0.02em',
          borderRadius: corpo * 0.42,
          padding: `${corpo * 0.37}px ${corpo * 0.47}px`
        }}
      >
        {NOME_SELO}
      </span>

      <span aria-hidden="true" className="min-w-0">
        <span
          className="block leading-none whitespace-nowrap"
          style={{ fontSize: corpo, color: corDoNome, letterSpacing: '-0.015em' }}
        >
          <span style={{ fontWeight: 400 }}>{NOME_PREFIXO}</span>
          <span style={{ fontWeight: 700 }}>{NOME_SUFIXO}</span>
        </span>

        {assinatura && (
          <span
            className="block leading-tight whitespace-nowrap"
            style={{ fontSize: corpo * 0.42, color: corDaAssinatura, marginTop: corpo * 0.16 }}
          >
            {ASSINATURA}
          </span>
        )}
      </span>
    </div>
  )
}
